import { useCallback } from "react";

const useShorten = () => {
  const shorten = useCallback((address, length = 5) => {
    if (!address) return "";
    return `${address.substring(0, length)}...${address.substring(
      address.length - 3
    )}`;
  }, []);

  return shorten;
};

export default useShorten;
